/* eslint-disable react/no-array-index-key */
import React from 'react';
import {NavLink} from 'react-router-dom';

import './submenu.scss';

const SubMenu = ({nav, children}) => (
  <nav className="sub-nav">
    {nav.map((item, i) => (
      <NavLink key={i} to={item.url} className={item.className && item.className} exact>
        {item.icon}
        {item.title}
      </NavLink>
    ))}
    {children}
  </nav>
);

export default SubMenu;
